import CustomTip from '../components/CustomTip';
import sharedContainer from './CustomTipSharedContainer';

export default sharedContainer(CustomTip);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/CustomTip.js